import {
    AfterViewInit,
    Component,
    ElementRef,
    OnDestroy,
    OnInit
} from '@angular/core';

import { Certificate, SiteApiService } from '../../core/services/api.service';

@Component({
    selector: 'app-certificates',
    templateUrl: './certificates.component.html'
})
export class CertificatesComponent implements OnInit, AfterViewInit, OnDestroy {

    certificates: Certificate[] = [];
    filteredCertificates: Certificate[] = [];

    categories: string[] = [
        'All Certificates',
        'Quality',
        'HSE',
        'Supplier',
        'Testing',
        'Manufacturing',
        'Logistics'
    ];

    selectedCategory = 'All Certificates';

    loading = false;
    errorMessage = '';

    private observer: IntersectionObserver | null = null;

    constructor(
        public siteApi: SiteApiService,
        private elementRef: ElementRef
    ) { }

    ngOnInit(): void {
        this.getCertificates();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.initRevealAnimation();
        }, 300);
    }

    ngOnDestroy(): void {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    getCertificates(): void {
        this.loading = true;
        this.errorMessage = '';

        this.siteApi.getCertificates().subscribe(
            (data: Certificate[]) => {
                this.certificates = data || [];
                this.applyFilter('All Certificates');
                this.loading = false;

                setTimeout(() => {
                    this.initRevealAnimation();
                }, 150);
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Certificates could not be loaded.';
                this.loading = false;
            }
        );
    }

    applyFilter(category: string): void {
        this.selectedCategory = category;

        if (category === 'All Certificates') {
            this.filteredCertificates = this.certificates;
        } else {
            this.filteredCertificates = this.certificates.filter(x =>
                (x.category || '').toLowerCase() === category.toLowerCase()
            );
        }

        setTimeout(() => {
            this.initRevealAnimation();
        }, 80);
    }

    private initRevealAnimation(): void {
        const elements = this.elementRef.nativeElement.querySelectorAll('.reveal');

        if (!elements || elements.length === 0) {
            return;
        }

        if (this.observer) {
            this.observer.disconnect();
        }

        this.observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const el = entry.target as HTMLElement;
                        el.classList.add('show');
                        this.observer?.unobserve(el);
                    }
                });
            },
            {
                threshold: 0.14
            }
        );

        elements.forEach((el: HTMLElement) => {
            el.classList.remove('show');
            this.observer?.observe(el);
        });
    }
}